import { cn } from '@bem-react/classname'
import { getCatalog, haveEmpty, selectCatalog, setShowEmpty, setStat } from 'modules/Catalog'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './StatsSelector.scss'
import Text from '../../../components/Text'
import { selectorIsUAExam } from 'modules/Exam/selectors'

const StatsSelector: FC = () => {
  const state = useSelector(selectCatalog)
  const cat = getCatalog(state)
  const dispatch = useDispatch()
  const sStat = (val: string) => () => dispatch(setStat(val))
  const cnStat = cn('StatSelector')
  const cnStatB = cn('StatSelectorBtn StatSelectorBtn')
  const isUAExam = useSelector(selectorIsUAExam)
  function getDescriptionSelector(currentSelect: string) {
    if (currentSelect.includes('seen')) {
      if (isUAExam) {
        return 'Не вирішувалося із загальної кількості завдань'
      } else {
        return 'Не решалось из общего количества заданий'
      }
    } else if (currentSelect.includes('right')) {
      if (isUAExam) {
        return 'Вирішено правильно з тих, що вирішувалося'
      } else {
        return 'Решено верно из тех, что решалось'
      }
    } else if (currentSelect.includes('wrong')) {
      if (isUAExam) {
        return 'Вирішено з помилкою з тих, що вирішувалося'
      } else {
        return 'Решено с ошибкой из тех, что решалось'
      }
    } else {
      if (isUAExam) {
        return 'Усього завдань у каталозі'
      } else {
        return 'Всего заданий в каталоге'
      }      
    }
  }

  return (
    <div className={cnStat()}>
      {!cat?.no_stats ? (
        state.statEnabled ? (
          <div className={cnStat('line_flex')}>
            <div className={cnStat('description_selector')}>
              <Text>{getDescriptionSelector(state.activeStat)}</Text>
            </div>
            <div className={cnStat('selectors_btn')}>
              <div>
                {cat?.have_clones ? <>{isUAExam ? `Прототипи:` : `Прототипы:`} </> : ''}
                <span
                  title="Всего заданий в базе"
                  onClick={sStat('')}
                  className={
                    cnStatB('all') +
                    ' ' +
                    (state.activeStat === '' ? 'StatSelectorBtn-active' : '')
                  }
                ></span>
                <span
                  title="Из них не решалось"
                  onClick={sStat('seen')}
                  className={
                    cnStatB('seen') +
                    ' ' +
                    (state.activeStat === 'seen'
                      ? 'StatSelectorBtn-active'
                      : '')
                  }
                ></span>
                <span
                  title="Из них решено верно"
                  onClick={sStat('right')}
                  className={
                    cnStatB('right') +
                    ' ' +
                    (state.activeStat === 'right'
                      ? 'StatSelectorBtn-active'
                      : '')
                  }
                ></span>
                <span
                  title="Из них решено с ошибкой"
                  onClick={sStat('wrong')}
                  className={
                    cnStatB('wrong') +
                    ' ' +
                    (state.activeStat === 'wrong'
                      ? 'StatSelectorBtn-active'
                      : '')
                  }
                ></span>
              </div>
              {cat?.have_clones ? (
                <div>
                  Аналоги:
                  <span
                    title="Всего заданий в базе"
                    onClick={sStat('clones')}
                    className={
                      cnStatB('all') +
                      ' ' +
                      (state.activeStat === 'clones'
                        ? 'StatSelectorBtn-active'
                        : '')
                    }
                  ></span>
                  <span
                    title="Из них не решалось"
                    onClick={sStat('seen_clones')}
                    className={
                      cnStatB('seen') +
                      ' ' +
                      (state.activeStat === 'seen_clones'
                        ? 'StatSelectorBtn-active'
                        : '')
                    }
                  ></span>
                  <span
                    title="Из них решено верно"
                    onClick={sStat('right_clones')}
                    className={
                      cnStatB('right') +
                      ' ' +
                      (state.activeStat === 'right_clones'
                        ? 'StatSelectorBtn-active'
                        : '')
                    }
                  ></span>
                  <span
                    title="Из них решено с ошибкой"
                    onClick={sStat('wrong_clones')}
                    className={
                      cnStatB('wrong') +
                      ' ' +
                      (state.activeStat === 'wrong_clones'
                        ? 'StatSelectorBtn-active'
                        : '')
                    }
                  ></span>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          <>{isUAExam ? `Увійдіть під своїм ім'ям, щоб побачити статистику` : 'Войдите под своим именем чтобы увидеть статистику'}</>
        )
      ) : (
        <div
          style={{
            width: 70,
            textAlign: 'center',
            marginRight: 70,
            float: 'right',
          }}
        >
          {cat.no_stats}
        </div>
      )}
      {state.showEmpty||!haveEmpty(state)?'':<span onClick={()=>dispatch(setShowEmpty())} className={cnStat('show-empty')}>показать пустые</span>}
    </div>
  )
}

export default StatsSelector
